import type { DashboardData } from '@/hooks/dashboardDataTypes'

export type CommissionsTabView = {
  totalPending: number
  totalPaid: number
  totalReversed: number
  totalCount: number
  totalValue: number
  recentCommissions: {
    id: string
    sellerName: string
    dealTitle: string
    empresa: string
    dealValue: number
    rate: number
    commissionValue: number
    status: string
    closedAt: string | null
  }[]
  topBeneficiaries: {
    userId: string
    name: string
    count: number
    totalValue: number
  }[]
}

function centsToReais(centavos: number): number {
  return centavos / 100
}

function statusBucket(status: string): 'pending' | 'paid' | 'reversed' | 'other' {
  const normalized = status.toUpperCase()
  if (normalized === 'PENDENTE') return 'pending'
  if (normalized === 'PAGO') return 'paid'
  if (normalized === 'ESTORNADO') return 'reversed'
  return 'other'
}

export function emptyCommissionsTabView(): CommissionsTabView {
  return {
    totalPending: 0,
    totalPaid: 0,
    totalReversed: 0,
    totalCount: 0,
    totalValue: 0,
    recentCommissions: [],
    topBeneficiaries: [],
  }
}

export function mapCommissionsTabView(data: DashboardData): CommissionsTabView | null {
  if (!data.commissions) return null

  let totalPending = 0
  let totalPaid = 0
  let totalReversed = 0

  for (const row of data.commissions.byStatus) {
    const value = centsToReais(row.totalCentavos)
    const bucket = statusBucket(row.status)
    if (bucket === 'pending') totalPending += value
    if (bucket === 'paid') totalPaid += value
    if (bucket === 'reversed') totalReversed += value
  }

  return {
    totalPending,
    totalPaid,
    totalReversed,
    totalCount: data.commissions.totalCount,
    totalValue: centsToReais(data.commissions.totalCentavos),
    recentCommissions: [],
    topBeneficiaries: data.commissions.topBeneficiaries.map((row) => ({
      userId: row.userId,
      name: row.name,
      count: row.count,
      totalValue: centsToReais(row.totalCentavos),
    })),
  }
}

export function formatCommissionStatusLabel(status: string): string {
  const normalized = status.toUpperCase()
  if (normalized === 'PENDENTE') return 'Pendente'
  if (normalized === 'PAGO') return 'Pago'
  if (normalized === 'ESTORNADO') return 'Estornado'
  return status
}

export function commissionStatusVariant(
  status: string,
): 'warning' | 'success' | 'danger' | 'muted' {
  const normalized = status.toUpperCase()
  if (normalized === 'PENDENTE') return 'warning'
  if (normalized === 'PAGO') return 'success'
  if (normalized === 'ESTORNADO') return 'danger'
  return 'muted'
}
